export const SANITY_PROJECT_ID = "z6ex5ahr";
export const SANITY_DATASET = "production";
export const SANITY_API_VERSION = "2022-03-07";
export const SANITY_TOKEN = "";
